import { useCallback, useState } from 'react';
import { useLayoutContext } from '../contexts/LayoutContext';

export const useAppLayout = () => {
  const { isMRV, handleCompanyToggle, onTrocarLoja, temMultiplasLojas, nomeLojaAtiva } =
    useLayoutContext();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [activeSection, setActiveSection] = useState(null);

  const toggleSidebar = useCallback(() => {
    setIsSidebarCollapsed(prev => !prev);
  }, []);

  const handleSetActiveSection = useCallback(sectionId => {
    setActiveSection(sectionId);
  }, []);

  return {
    isMRV,
    handleCompanyToggle,
    onTrocarLoja,
    temMultiplasLojas,
    nomeLojaAtiva,
    isSidebarCollapsed,
    toggleSidebar,
    activeSection,
    setActiveSection: handleSetActiveSection,
  };
};
